import React from "react";
import { DOC_STATUSES } from "./vocab";

const inputCls = "w-full bg-[#050505] border border-white/10 rounded-md px-3 py-2 text-sm font-mono focus:outline-none focus:border-white/30";

function Field({ label, children }) {
    return <div><div className="label-xs mb-1.5">{label}</div>{children}</div>;
}

export const IRB_KEYS = ["irb_approved", "irb_approval_date", "irb_name"];

export function ValidityFields({ value, onChange, testId = "dl-validity", showIrb = true, irbHint }) {
    const v = value || {};
    const set = (k, val) => onChange({ ...v, [k]: val });
    const irb = v.irb_approved === true ? "true" : v.irb_approved === false ? "false" : "";
    return (
        <div className="border border-white/10 rounded-md p-3 space-y-3" data-testid={testId}>
            <div className="label-xs text-white/60">Validity</div>
            <div className="grid grid-cols-3 gap-3">
                <Field label="Valid from"><input type="date" value={v.valid_from || ""} onChange={(e) => set("valid_from", e.target.value)} data-testid={`${testId}-valid-from`} className={inputCls} /></Field>
                <Field label="Valid to"><input type="date" value={v.valid_to || ""} onChange={(e) => set("valid_to", e.target.value)} data-testid={`${testId}-valid-to`} className={inputCls} /></Field>
                <Field label="Expires at"><input type="date" value={v.expires_at || ""} onChange={(e) => set("expires_at", e.target.value)} data-testid={`${testId}-expires-at`} className={inputCls} placeholder="defaults to valid to" /></Field>
            </div>
            {showIrb ? (
                <div className="grid grid-cols-3 gap-3" data-testid={`${testId}-irb-block`}>
                    <Field label="IRB approved">
                        <select value={irb} onChange={(e) => set("irb_approved", e.target.value === "" ? null : e.target.value === "true")} data-testid={`${testId}-irb-approved`} className={inputCls}>
                            <option value="">unknown</option><option value="true">yes</option><option value="false">no</option>
                        </select>
                    </Field>
                    <Field label="IRB approval date"><input type="date" value={v.irb_approval_date || ""} onChange={(e) => set("irb_approval_date", e.target.value)} data-testid={`${testId}-irb-date`} className={inputCls} /></Field>
                    <Field label="IRB name"><input value={v.irb_name || ""} onChange={(e) => set("irb_name", e.target.value)} data-testid={`${testId}-irb-name`} className={inputCls} placeholder="e.g. WCG IRB" /></Field>
                </div>
            ) : (
                <div className="text-[11px] text-white/35" data-testid={`${testId}-irb-na`}>{irbHint || "IRB approval fields are not applicable — they appear only for IRB-relevant contexts (ICF, protocol, regulatory, safety)."}</div>
            )}
            <div className="grid grid-cols-3 gap-3">
                <Field label="Version"><input value={v.version_label || ""} onChange={(e) => set("version_label", e.target.value)} data-testid={`${testId}-version`} className={inputCls} placeholder="v2.0" /></Field>
                <Field label="Document date"><input type="date" value={v.document_date || ""} onChange={(e) => set("document_date", e.target.value)} data-testid={`${testId}-document-date`} className={inputCls} /></Field>
                <Field label="Status">
                    <select value={v.status || ""} onChange={(e) => set("status", e.target.value || null)} data-testid={`${testId}-status`} className={inputCls}>
                        <option value="">—</option>{DOC_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                </Field>
            </div>
            <Field label="Notes"><input value={v.notes || ""} onChange={(e) => set("notes", e.target.value)} data-testid={`${testId}-notes`} className={inputCls} /></Field>
        </div>
    );
}

export const META_KEYS = ["valid_from", "valid_to", "expires_at", "irb_approved", "irb_approval_date", "irb_name", "version_label", "document_date", "effective_date", "language", "status", "notes"];

export function metaPatch(next, prev) {
    const out = {};
    META_KEYS.forEach((k) => {
        const n = next?.[k] === "" ? null : next?.[k] ?? null;
        const p = prev?.[k] ?? null;
        if (n !== p) out[k] = n;
    });
    return out;
}

export function appendMeta(fd, meta) {
    META_KEYS.forEach((k) => { const v = meta?.[k]; if (v !== undefined && v !== null && v !== "") fd.append(k, String(v)); });
}
